import { useCallback, useContext, useState } from 'react';
import { SiteSettingsContext } from '@namespace/cms';
import { ConfirmModal } from '@namespace/common';
import { useI18n } from '@namespace/i18n';
import {
  fundsAggregatedStatusesMap,
  fundsBonusSystemStates
} from '../../constants';
import { useFundsBonusActions } from '../../hooks/useFundsBonusActions';
import { useFundsBonus } from '../../store';
import { BonusCard } from '../BonusCard';

export const FundsBonusCard = ({
  bonusId,
  onAccept,
  onWagerAccept,
  isThereActiveBonus
}) => {
  const [isDisplayConfirmModal, setIsDisplayConfirmModal] = useState(false);
  const bonus = useFundsBonus(bonusId);
  const [settings] = useContext(SiteSettingsContext);
  const { otherSettings = {} } = settings || {};
  const { bonuses = {} } = otherSettings;
  const { isShowMultilangImages = false, isShowFundsImages = false } = bonuses;
  const { t, language } = useI18n();
  const { openDetails, acceptBonus, isRequestProcessing } =
    useFundsBonusActions(bonus, onAccept, onWagerAccept);
  const {
    imageUrl,
    bonusName,
    expireTime,
    bonusModelId,
    bonusType,
    state,
    isShowButton,
    buttonType,
    isWagerEnabled,
    isShowWagerButton,
    progressBarStatus,
    countdownTimerTitle,
    isCountdownTimerEnabled,
    bonusDetailsList,
    bonusImageType
  } = bonus;

  const bonusImage = isShowFundsImages ? bonusImageType : 'funds';

  const onBonusAccept = useCallback(
    (e) => {
      e.stopPropagation();
      return isThereActiveBonus && state === fundsBonusSystemStates.PROPOSED
        ? setIsDisplayConfirmModal(true)
        : acceptBonus(e);
    },
    [acceptBonus, isThereActiveBonus, state]
  );

  return (
    <BonusCard
      bonus={bonus}
      onAccept={onBonusAccept}
      isShowButton={isShowButton}
      buttonTitle={t(`web.personaloffice.bonuses.button.${buttonType}`)}
      progressBarStatus={progressBarStatus}
      isWagerEnabled={isWagerEnabled}
      status={fundsAggregatedStatusesMap[state]}
      countdownTimerTitle={countdownTimerTitle}
      isCountdownTimerEnabled={isCountdownTimerEnabled}
      openDetails={openDetails}
      detailsList={bonusDetailsList}
      imageUrl={
        imageUrl ||
        `/images/bonuses/${
          isShowMultilangImages ? `${language}/` : ''
        }${bonusImage}.png`
      }
      bonusName={bonusName}
      bonusModelId={bonusModelId}
      expireTime={expireTime}
      isRequestProcessing={isRequestProcessing}
      bonusType={bonusType}
      intent={isShowWagerButton ? 'secondary' : 'primary'}
      cardType="funds"
    >
      {isDisplayConfirmModal && (
        <ConfirmModal
          data-testid="confirm-modal"
          title={t('web.personaloffice.bonuses.notification.changebonus')}
          subtitle={t('web.personaloffice.bonuses.notification.changebonus2')}
          confirm={t('web.personaloffice.bonuses.button.changebonus.confirm')}
          close={t('web.personaloffice.bonuses.button.changebonus.close')}
          onConfirm={(e) => {
            acceptBonus(e);
            setIsDisplayConfirmModal(false);
          }}
          onClose={(e) => {
            e.stopPropagation();
            setIsDisplayConfirmModal(false);
          }}
        />
      )}
    </BonusCard>
  );
};
